import React, { useEffect, useState } from 'react';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { InvoiceMenu } from '../TitleList';
import { selectFirm, selectParty } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import axios from 'axios';
import { fetchInvoiceMemo, insertInvoiceEntry } from '../../Store/PHPSlice/Invoice/InvoiceApi';
import { selectInvMemo } from '../Selectors/PackSelector/PackingSelector';


const InvoiceEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        invMemo: '',
        firm: '',
        party: '',
        totqty: '0',
        totamt: '0',
        userId: userdata?.ID
    });
    const [invoiceData, setInvoiceData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectParty);
    const invMemo = useSelector(selectInvMemo);

    const baseUrl = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchInvoiceMemo());
    }, [dispatch]);

    useEffect(() => {
        if (invMemo?.data && invMemo.data?.invMemo) {
            const Id = invMemo.data.invMemo;
            setFormData(prev => ({
                ...prev,
                invMemo: Id
            }));
        }
    }, [invMemo]);

    const isDesktop = useMediaQuery('(min-width:768px)');
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

    };

    const handleSelectChange = (index) => {
        // Toggle selection for the row at the given index
        setSelectedRows((prevSelectedRows) => {
            if (prevSelectedRows.includes(index)) {
                // If already selected, remove it from the array
                return prevSelectedRows.filter(item => item !== index);
            } else {
                // Otherwise, add it to the array
                return [...prevSelectedRows, index];
            }
        });
    };

    const handleAddData = () => {
        const selectFirm = firmlist?.data?.find(item => item.ID == formData.firm);
        const firmNm = selectFirm ? selectFirm.firmNm : '';

        const selectParty = partylist?.data?.find(item => item.ID == formData.party);
        const partyNm = selectParty ? selectParty.partyNm : '';
        const newData = {
            firmNm: firmNm,
            firmId: formData.firm,
            partyNm: partyNm,
            partyId: formData.party,
            billdt: '',
            billNo: '',
            transport: '',
            totqty: 0,
            totamt: 0
        };

        setInvoiceData(prev => {
            const updatedData = [...prev, newData];
            return updatedData;
        });

    };

    const handleDelete = () => {
        // Step 1: Remove selected items from packData
        setInvoiceData((prevInvoice) => {
            const newInvoice = prevInvoice.filter((item, index) => !selectedRows.includes(index));

            // Step 2: Remove the corresponding items from selectedItems
            setSelectedItems((prevSelectedItems) => {
                // Find the IDs of the items to be removed (those in selectedRows)
                const itemsToRemove = selectedRows
                    .map(index => prevInvoice[index]?.ID) // Get the IDs of the items in selectedRows
                    .filter(id => id !== undefined); // Filter out undefined values (in case the index is invalid)

                // Remove these IDs from selectedItems
                return prevSelectedItems.filter(id => !itemsToRemove.includes(id));
            });

            return newInvoice;
        });

        // Step 3: Clear selected rows after deletion
        setSelectedRows([]);

        // const updatedPackData = [...packData];
        // const totalQty = updatedPackData.reduce((sum, item) => sum + (item.qty || 0), 0);
        // setFormData(prev => ({
        //     ...prev,
        //     totQty: totalQty
        // }));
    };

    const handleInputChange2 = (index, field, value) => {
        const updatedInvoiceData = [...invoiceData];
        updatedInvoiceData[index][field] = value.toUpperCase();
        setInvoiceData(updatedInvoiceData);

        const sumTotQty = updatedInvoiceData.reduce((sum, item) => sum + (parseFloat(item.totqty) || 0), 0);
        const sumTotAmt = updatedInvoiceData.reduce((sum, item) => sum + (parseFloat(item.totamt) || 0), 0);

        setFormData(prevFormData => ({
            ...prevFormData,
            totqty: sumTotQty,
            totamt: sumTotAmt
        }));
    };

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Invoice Memo', name: 'invMemo', type: 'readOnly' }
    ];

    const dropdownlistfirst = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmlist?.data,
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Party',
            id: 'party',
            options: partylist?.data,
            value: formData.party,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const fieldsecond = [
        { label: 'Total Qty.', name: 'totqty', type: 'readOnly' },
        { label: 'Total Amt.', name: 'totamt', type: 'readOnly' },
    ];

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function object(formData, invoiceData) {
        const data = {
            dt: formData.dt,
            invMemo: formData.invMemo,
            userId: formData.userId,
            invoiceData: invoiceData
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        const finalObject = object(formData, invoiceData);
        // console.log(finalObject)

        dispatch(insertInvoiceEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Records Inserted");
                window.location.reload();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };
    return (
        <>
            <TitleBar data={InvoiceMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Invoice Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {fieldsecond.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                <Grid item xs={12} style={{ textAlign: 'center' }}>
                                    <Button variant="contained" color="primary" size='small' style={{ marginRight: '5vh' }} onClick={handleAddData}>Add</Button>
                                    <Button variant="contained" color="primary" size='small' disabled={selectedRows.length === 0} onClick={handleDelete}>Delete</Button>
                                </Grid>

                                {Array.isArray(invoiceData) && invoiceData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table style={isDesktop ? { width: '100%' } : { width: '100%' }}>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>
                                                            {/* <input
                                                                type="checkbox"
                                                                onChange={() => {
                                                                    // Select all checkboxes when the header checkbox is toggled
                                                                    if (selectedRows.length === packData.length) {
                                                                        setSelectedRows([]); // Deselect all if already selected
                                                                    } else {
                                                                        setSelectedRows(packData.map((_, index) => index)); // Select all
                                                                    }
                                                                }}
                                                                checked={selectedRows.length === packData.length}
                                                            />Select */}
                                                            Select
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Firm Name</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Party Name</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Bill Date</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Bill No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Transport</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Total Qty.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Total Amt.</TableCell>
                                                    </TableRow>
                                                    {
                                                        invoiceData.map((item, index) => (
                                                            <TableRow key={index}>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedRows.includes(index)}
                                                                        onChange={() => handleSelectChange(index)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.firmNm}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.partyNm}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="date"
                                                                        value={item.billdt || '0'}  // Ensure value is either the number or an empty string
                                                                        name="billdt"
                                                                        style={{ width: '140px', padding: '1px' }}
                                                                        onChange={(e) => handleInputChange2(index, 'billdt', e.target.value)}
                                                                    />

                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.billNo || ''}  // Ensure value is either the number or an empty string
                                                                        name="billNo"
                                                                        style={{ width: '100px', padding: '1px' }}
                                                                        placeholder='Bill No'
                                                                        onChange={(e) => handleInputChange2(index, 'billNo', e.target.value)}
                                                                    />

                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.transport || ''}  // Ensure value is either the number or an empty string
                                                                        name="transport"
                                                                        style={{ width: '120px', padding: '1px' }}
                                                                        placeholder='Transport Name'
                                                                        onChange={(e) => handleInputChange2(index, 'transport', e.target.value)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.totqty || ''}  // Show balance qty
                                                                        name="totqty"
                                                                        style={{ width: '100px', padding: '1px' }}
                                                                        placeholder='Total Qty'
                                                                        onChange={(e) => handleInputChange2(index, 'totqty', e.target.value)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.totamt || ''}  // Show total qty
                                                                        name="totamt"
                                                                        style={{ width: '100px', padding: '1px' }}
                                                                        placeholder='Total Amt'
                                                                        onChange={(e) => handleInputChange2(index, 'totamt', e.target.value)}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </>
                                }



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={invoiceData.length === 0}>Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default InvoiceEntry;
